import React from "react";
import './CurrentNew.css';
import { GET_CURRENT_NEW } from "../../../../queries";
import { withRouter } from "react-router-dom";
import { withAuth } from "../../../withAuth";
import Query from "react-apollo/Query";
import TopPafeInfo from "../../../Elements/BigElements/TopPageInfo/TopPafeInfo";

class CurrentNew extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            postid: props.match.params.postid
        }
    };

    render() {
        const { postid } = this.state;
        return (
            <div className="AllPosts">
                <TopPafeInfo session={this.props.session} />
                <div className="PersonalPageMain StandartPartMain">

                        
                    
                    <Query query={GET_CURRENT_NEW} variables={{ _id: postid }}>
                        {({ data, loading, error }) => {
                            if (loading) return <div>loading</div>;
                            if (error) return <div>error</div>;

                            console.log(data.getCurrentNew);
                            const post = data.getCurrentNew[0];

                            return <div className="PersonalPageMainPersonalInformation StandartBigElement">
                                <div className="IndexMainElementIn">
                                    <div className="StandartElementTitle">{post.title}</div>
                                    <div className="StandartElementTopBorder"/>
                                </div>
                                    <div class="row post-main-area">
                                        <div className="col-md-12">
                                            <div className="post-main-area" dangerouslySetInnerHTML={{__html: post.text}}>
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>
                        }
                        }
                    </Query>
                            
                </div>
            </div>
        )
    }
}
export default withAuth(session => session && session.getCurrentUser)(withRouter(CurrentNew));
